module.exports = __webpack_public_path__ + "static/img/028 4.160f981f.jpg";